import SelectorEngine from './dom/selector-engine';
import { ClassNames } from './dom/css-classes';

export const HAS_ICON_CLASS = 'has-icon';
const IS_INVALID_WRAPPER_CLASS = 'is-invalid-wrapper';
export const SELECTOR_ERROR_CLASS = '.lta-text-input--error';
const INPUT_PARENT = '.lta-search-input-field';

export const InputTypes = {
	SELECTOR_INPUT: 'input',
	SELECTOR_RADIO: 'radio',
	SELECTOR_SELECT: 'select'
};

export function validFormElementValue(formElementValue, elementObject = {}) {
	const {
		element,
		type,
		hasIcon,
		errorMessage,
		hasLimit,
		charLimit,
		hasMaxLimit,
		maxCharLimit,
		isTextArea,
		minLength,
		minLengthErrorMessage,
		maxCharErrorMessage,
		allowNumbersOrSpecialCharacters,
		invalidErrorMessage
	} = elementObject;
	const errorElement = SelectorEngine.findOne(SELECTOR_ERROR_CLASS, element);

	if (!formElementValue) {
		addInvalidClasses(element, hasIcon);
		errorElement.innerHTML = errorMessage;
		return false;
	} else {
		// This is referring to the minimum char limit
		if (hasLimit && formElementValue?.length < charLimit) {
			addInvalidClasses(element, hasIcon);
			errorElement.innerHTML = minLengthErrorMessage || errorMessage;
			return false;
		} else if (hasMaxLimit && formElementValue?.length > maxCharLimit) {
			addInvalidClasses(element, hasIcon);
			errorElement.innerHTML = maxCharErrorMessage || errorMessage;
			return false;
		} else if (isTextArea && !isNaN(minLength) && minLength !== undefined && formElementValue?.length < minLength) {
			addInvalidClasses(element, hasIcon);
			errorElement.innerHTML = minLengthErrorMessage || errorMessage;
			return false;
		} else if (type === 'email' && !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(formElementValue)) {
			addInvalidClasses(element, hasIcon);
			errorElement.innerHTML = errorMessage;
			return false;
		} else if (type === 'tel' && !isNaN(minLength) && minLength !== undefined && formElementValue?.length < minLength) {
			addInvalidClasses(element, hasIcon);
			errorElement.innerHTML = minLengthErrorMessage || errorMessage;
			return false;
		} else if (type === 'name' && !/^(?:\p{L}\.?|\p{L}+(?:[.'’-]\p{L}+)*)(?:\s+(?:\p{L}\.?|\p{L}+(?:[.'’-]\p{L}+)*))*$/u.test(formElementValue)) {
			addInvalidClasses(element, hasIcon);
			errorElement.innerHTML = errorMessage;
			return false;
		} else if (allowNumbersOrSpecialCharacters === false && /[0-9!@#$%^&*(),.?":{}|<>]/.test(formElementValue)) {
			addInvalidClasses(element, hasIcon);
			errorElement.innerHTML = invalidErrorMessage || errorMessage;
			return false;
		} else if (/^ *$/.test(formElementValue)) {
			addInvalidClasses(element, hasIcon);
			errorElement.innerHTML = invalidErrorMessage || errorMessage;
			return false;
		} else {
			removeInvalidClasses(element);
			errorElement.innerHTML = '';
			return true;
		}
	}
}

export function addInvalidClasses(element, hasIcon) {
	element.classList.add(ClassNames.Invalid);
	if (element.closest(INPUT_PARENT)) {
		element.closest(INPUT_PARENT)?.classList.add(IS_INVALID_WRAPPER_CLASS);
	} else {
		element.classList.add(ClassNames.Focused);
	}
	if (hasIcon) {
		element.classList.add(HAS_ICON_CLASS);
	}
}

export function removeInvalidClasses(element) {
	element.classList.remove(ClassNames.Invalid);
	element.classList.remove(ClassNames.Focused);
	element.classList.remove(HAS_ICON_CLASS);
	element.closest(INPUT_PARENT)?.classList.remove(IS_INVALID_WRAPPER_CLASS);
}
